import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { setNotificationAction } from "../../../Redux/actions";
import { getAllSectorsApi, updateUserSectorApi } from "../../Sectors/apiCalls";
import "./MemberDetail.scss";

// no sector = the member sees roles and skills of all industries
const noSector = { value: 0, label: "All industries (no sector)" };

class UserDetails extends Component {
    state = {
        sectorOptions: [noSector],
        sectorId: 0,
    };

    componentDidMount() {
        getAllSectorsApi().then((res) =>
            this.setState({
                sectorOptions: [
                    noSector,
                    ...(res?.items || []).map((s) => ({
                        value: s.SectorId,
                        label: s.IsActive ? s.SectorValueEn : `${s.SectorValueEn} (inactive)`,
                    })),
                ],
            })
        );
        this.setState({ sectorId: this.props.selectedMember.SectorId || 0 });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedMember.UserId !== this.props.selectedMember.UserId) {
            this.setState({ sectorId: this.props.selectedMember.SectorId || 0 });
        }
    }

    handleSectorChange = (option) => {
        const { selectedMember } = this.props;
        const sectorId = option ? option.value : 0;
        updateUserSectorApi(selectedMember.UserId, sectorId || null).then((res) => {
            if (res?.success) {
                // keep the members list in sync without reloading it
                selectedMember.SectorId = sectorId || null;
                this.setState({ sectorId });
                this.props.setNotificationAction({ message: res.message, status: "success" });
            } else {
                this.props.setNotificationAction({
                    message: res?.message || "Something went wrong try again",
                    status: "error",
                });
            }
        });
    };

    render() {
        const { labels, selectedMember, getResumeDetail } = this.props;
        return (
            <div className="user-detail-component">
                {!selectedMember.UserId ? (
                    <React.Fragment>{labels.NO_ITEM_LABEL}</React.Fragment>
                ) : (
                    <div className="MsgWrapper">
                        <div className="companyBigIcon">
                            <div className={`dashItemImg no-dp"}`}>
                                <img
                                    className="roundeImg"
                                    src={selectedMember.ProfilePicture}
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="titleLabel">{selectedMember.UserFirstname + " " + (selectedMember.UserLastname ? selectedMember.UserLastname : "")}</div>
                        <div className="feedbackWrap">
                            <div className="msgItemDiv">
                                <div>
                                    <label className="leftLabel">
                                        {labels.TYPE_LABEL}
                                    </label>
                                    <label className="rightLabel">
                                        {selectedMember.IsFreelancer ? labels.IPRO_NAVIGATION_ROLE_LABEL : labels.SEARCHER_NAVIGATION_ROLE_LABEL}
                                    </label>
                                </div>
                                {selectedMember &&
                                    selectedMember.UserEmail && (
                                        <div>
                                            <label className="leftLabel">
                                                {labels.EMAIL_LABEL}
                                            </label>
                                            <label className="rightLabel">
                                                {selectedMember.UserEmail}
                                            </label>
                                        </div>
                                    )}
                                <div>
                                    <label className="leftLabel">
                                        {"Sector"}
                                    </label>
                                    <div className="rightLabel member-sector">
                                        <Select
                                            value={this.state.sectorId}
                                            options={this.state.sectorOptions}
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.handleSectorChange}
                                        />
                                    </div>
                                </div>
                                {selectedMember &&
                                    selectedMember.CountryName && (
                                        <div>
                                            <label className="leftLabel">
                                                {labels.iProOpportunityNewDetailLblCountry}
                                            </label>
                                            <label className="rightLabel">
                                                {selectedMember.CountryName}
                                            </label>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        labels: state.labels
    };
}
export default connect(mapStateToProps, { setNotificationAction })(UserDetails);